export default __webpack_public_path__ + "static/logo-63db8a9f3af6c068be434d681ccdfd2e.webp";